// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    RESET_SUBUSER_PASSWORD_REQUEST
} from 'Redux/actionTypes';

// Actions
import {
    resetSubUserPasswordResult,
} from 'Redux/actions';

// Helpers
import { clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* resetSubUserPassword({ payload }) {
    try {
        let QUERY = `
            mutation resetSubUserPassword ($id: Int!) {
                result: resetSubUserPassword (id: $id)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(resetSubUserPasswordResult({ reset: data?.result }))
        //to update
    } catch (exc) {
        yield put(resetSubUserPasswordResult({ reset: false }))
        ExceptionManager(exc, 'Modules/users/.components/resetSubUserPassword/redux/saga', 'resetSubUserPassword');
    }
}

function* watchMethods() {
    yield takeEvery(RESET_SUBUSER_PASSWORD_REQUEST, resetSubUserPassword);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}